import { Box, Drawer, IconButton, Skeleton } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid2';

export default function WebUrlFormSkeleton() {
  const navigate = useNavigate();

  return (
    <Drawer
      anchor='right'
      open={true}
      onClose={() => navigate(-1)}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 400, md: 600 },
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 100001
        }
      }}
    >
      {/* Fixed Header Skeleton */}
      <Box
        sx={{
          px: { xs: 2, lg: 3 },
          py: { xs: 1.5, lg: 2 },
          borderBottom: '1px solid #DEDEDE',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexShrink: 0
        }}
      >
        <Skeleton variant='text' width={120} height={32} />
        <IconButton
          onClick={() => navigate(-1)}
          size='small'
          sx={{
            p: { xs: 0.75, lg: 1 }
          }}
        >
          <IoClose size={20} />
        </IconButton>
      </Box>

      {/* Form Content Skeleton */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Scrollable Content Skeleton */}
        <Box
          sx={{
            flex: 1,
            overflow: 'auto'
          }}
        >
          <Grid container padding={{ xs: 2, lg: 3 }} spacing={{ xs: 2, lg: 3 }}>
            {/* Name Field */}
            <Grid size={12}>
              <Skeleton variant='text' width={60} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
            </Grid>

            {/* Radio Buttons for Scrap Type */}
            <Grid size={12}>
              <Box display='flex' gap={{ xs: 2, lg: 3 }} mb={2} flexWrap={{ xs: 'wrap', sm: 'nowrap' }}>
                <Box display='flex' alignItems='center' gap={1}>
                  <Skeleton variant='rectangular' width={20} height={20} sx={{ borderRadius: '50%' }} />
                  <Skeleton variant='text' width={120} height={20} />
                </Box>
                <Box display='flex' alignItems='center' gap={1}>
                  <Skeleton variant='rectangular' width={20} height={20} sx={{ borderRadius: '50%' }} />
                  <Skeleton variant='text' width={100} height={20} />
                </Box>
              </Box>
            </Grid>

            {/* URL Input Field */}
            <Grid size={12} mb={2}>
              <Skeleton variant='text' width={40} height={20} sx={{ mb: 1 }} />
              <Box display='flex' alignItems='center' border='1px solid #e0e0e0' borderRadius={1} p={1}>
                <Skeleton variant='text' width={60} height={20} sx={{ mr: 1 }} />
                <Skeleton variant='text' width={200} height={20} />
              </Box>
            </Grid>

            {/* Exclude URLs Field (conditional) */}
            <Grid size={12}>
              <Skeleton variant='text' width={140} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' height={100} sx={{ borderRadius: 1 }} />
            </Grid>
          </Grid>
        </Box>

        {/* Fixed Footer Skeleton */}
        <Box
          sx={{
            px: { xs: 2, lg: 3 },
            py: { xs: 1.5, lg: 2 },
            borderTop: '1px solid #DEDEDE',
            display: 'flex',
            justifyContent: { xs: 'space-between', sm: 'flex-end' },
            gap: 2,
            flexShrink: 0,
            flexWrap: { xs: 'wrap', lg: 'nowrap' }
          }}
        >
          <Skeleton variant='rectangular' height={40} sx={{ borderRadius: 1, width: { xs: '48%', sm: 80 } }} />
          <Skeleton variant='rectangular' height={40} sx={{ borderRadius: 1, width: { xs: '48%', sm: 100 } }} />
        </Box>
      </Box>
    </Drawer>
  );
}
